import { jsx as _jsx } from "react/jsx-runtime";
import { assertContext } from '@bos/utils';
import { cs } from 'date-fns/locale';
import { createContext, useContext } from 'react';
import { defaultBreakpoints } from '../../const/sizes';
const configContext = createContext(null);
export const ConfigProvider = ({ children, config: { testIdAttributeName = 'data-test-id', isErrorTestAttributeName = 'data-is-error', isOpenTestAttributeName = 'data-is-open', isCheckedTestAttributeName = 'data-is-checked', breakpoints = defaultBreakpoints, dateFnsLocale = cs, }, }) => {
    const value = {
        testIdAttributeName,
        isErrorTestAttributeName,
        isOpenTestAttributeName,
        isCheckedTestAttributeName,
        breakpoints,
        dateFnsLocale,
    };
    return (_jsx(configContext.Provider, { value: value, children: children }));
};
export const useConfig = () => {
    const context = useContext(configContext);
    assertContext(context, 'configContext');
    return context;
};
